import { onMounted, onBeforeUnmount, createRef } from 'intact-vue-next';
export function useScroll() {
  var callbacks = [];
  var scrollRef = createRef();
  var scrollLeft = 0;
  function onScroll() {
    var newScrollLeft = scrollRef.value.scrollLeft;
    if (scrollLeft !== newScrollLeft) {
      scrollLeft = newScrollLeft;
      callbacks.forEach(function (fn) {
        return fn(scrollLeft);
      });
    }
  }
  onMounted(function () {
    scrollRef.value.addEventListener('scroll', onScroll, {
      passive: true
    });
  });
  onBeforeUnmount(function () {
    scrollRef.value.removeEventListener('scroll', onScroll);
  });
  return {
    callbacks: callbacks,
    scrollRef: scrollRef
  };
}